import { useLocation, useNavigate } from 'react-router-dom'

function parentPage(path: string): string {
  if (path.startsWith('/v2/funds/') || path.startsWith('/v2/subchain/')) return '/v2/funds'
  if (path.startsWith('/v2/documents/')) return '/v2/traces'
  if (path.startsWith('/v2/workbench/')) return '/v2/workbench'
  if (path.startsWith('/v2/admin/')) return '/v2/admin'
  return '/v2'
}

/** A direct bookmark has no prior app entry. Browser history.length also
 * counts external pages, so use the router's index and a safe app fallback. */
export default function BackButton({
  fallback,
  className = '',
}: {
  fallback?: string
  className?: string
}) {
  const location = useLocation()
  const navigate = useNavigate()
  const back = () => {
    const index = window.history.state?.idx
    if (Number.isInteger(index) && index > 0) {
      navigate(-1)
      return
    }
    const candidate = new URL(fallback ?? parentPage(location.pathname), window.location.origin)
    const safe =
      candidate.origin === window.location.origin && /^\/v2(?:\/|$)/.test(candidate.pathname)
    navigate(safe ? candidate.pathname + candidate.search + candidate.hash : '/v2', {
      replace: true,
    })
  }
  return (
    <button
      type="button"
      className={'history-back ' + className}
      onClick={back}
      data-testid="app-back"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        aria-hidden="true"
      >
        <path d="m10 5-7 7 7 7M3 12h18" />
      </svg>
      <span>Back</span>
    </button>
  )
}
